import styled from 'styled-components';

export const TooltipContentDiv = styled.div`
  box-shadow: 0px 12px 28px rgba(33, 39, 73, 0.2);
  row-gap: 12px;
  text-align: left;

  padding: 20px 24px 24px 24px;
  display: flex;

  flex-direction: column;
  border-radius: 8px;
  max-width: 609px;
`;

export const TooltipTextWrap = styled.div`
  &[data-hasdescription] {
    padding-bottom: 12px;
    border-bottom: 1px solid var(--beam-color-neutral-n300);
  }
`;
